<template>
  <b-card>
    <iframe
      :src="'https://vc3.sunnah.live/playback/presentation/2.3/' + slide"
      frameborder="0"
      style="height: 500px; width: 100%"
    ></iframe>
  </b-card>
</template>

<script>
import OnlineSessionController from "@/Controllers/OnlineSessionController";
export default {
  props: ["id"],
  data() {
    return {
      slide: "",
    };
  },
  async created() {
    if (this.$route.params.id) this.id = this.$route.params.id;
    const ctr = await new OnlineSessionController().Show(this.id, {
      with: ["attr"],
    });
    // console.log();
    const mateData = JSON.parse(ctr.attr.meta_data);

    this.slide = mateData.internalMeetingID;
  },
};
</script>

<style>
</style>